import { render, staticRenderFns } from "./imc_select.vue?vue&type=template&id=21f966c1&scoped=true&"
import script from "./imc_select.vue?vue&type=script&lang=js&"
export * from "./imc_select.vue?vue&type=script&lang=js&"
import style0 from "./imc_select.vue?vue&type=style&index=0&id=21f966c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f966c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21f966c1')) {
      api.createRecord('21f966c1', component.options)
    } else {
      api.reload('21f966c1', component.options)
    }
    module.hot.accept("./imc_select.vue?vue&type=template&id=21f966c1&scoped=true&", function () {
      api.rerender('21f966c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/shared/xml_fields/imc_select.vue"
export default component.exports